/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { gql, useMutation } from '@apollo/client';

export const useProductSubscription = () => {
    const PRODUCT_SUBSCRIPTIONS_GQL = gql`
        mutation AddProductTagSubscribtion($addProdRequest: AddProductTagSubscriptionRequest!) {
            addProductTagSubscription(addProdRequest: $addProdRequest)   
        }
    `
    const [productSubscriptionMutation] = useMutation(PRODUCT_SUBSCRIPTIONS_GQL);   
      return {
        productTagSubscriptionMutation:async (productSubscriptionObject) => {
        return await productSubscriptionMutation({variables:{"addProdRequest":productSubscriptionObject,context:{clientName:"notification"}}})
    }
    };
}